import styled from '@emotion/styled';

export const TransparentText = styled('div')((p) => ({
  color: 'transparent'
}));

// Transparent text, which can be used to put hidden data
// in the UI for easy debuggability
export const DebugText = TransparentText;
